export default "__VITE_ASSET__d647188a__"